
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quick-videos",
      function () {
        return require("private-next-pages/quick-videos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quick-videos"])
      });
    }
  